const Images = {
  "Sand Crawler": "./sandcrawler.png",
  "T-16 skyhopper": "./t16skyhopper.png",
  "X-34 landspeeder": "./x34landspeeder.png",
  "TIE/LN starfighter": "./tiefighter.png",
  Snowspeeder: "./snowspeeder.png",
  "TIE bomber": "./tiebomber.png",
  "AT-AT": "./atat.png",
  "AT-ST": "./atst.png",
  "Storm IV Twin-Pod cloud car": "./cloudcar.png",
  "Sail barge": "./sailbarge.png",
  Alderaan: "./alderaan.png",
  "Yavin IV": "./yavin4.png",
  Hoth: "./hoth.png",
  Dagobah: "./dagobah.png",
  Bespin: "./bespin.png",
  Endor: "./endor.png",
  Naboo: "./naboo.png",
  Coruscant: "./coruscant.png",
  Kamino: "./kamino.png",
  Geonosis: "./geonosis.png",
  "Luke Skywalker": "./luke.png",
  "Darth Vader": "./darthvader.png",
  "Leia Organa": "./leia.png",
  "Owen Lars": "./owen.png",
  "Beru Whitesun lars": "./beru.png",
  "C-3PO": "./c3p0.png",
  "R2-D2": "./r2d2.png",
  "R5-D4": "./r5d4.png",
  "Biggs Darklighter": "./bigg.png",
  "Obi-Wan Kenobi": "./obiwan.png",
  "Available Memory": ""
};

export default Images;
